/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable react/jsx-no-target-blank */
import React from 'react';
import { subject } from '../../service';
import RenderTour from './renderTour';

class KrpanoTour extends React.Component {

    constructor(props){
        super(props);
        this.state = {
            id : props.id,
            synchronized : props.synchronized,
            orientation: undefined
        };
    }

    componentDidMount(){
        this.subscription = subject.subscribe(res => {
          if(res.id != this.props.id && this.props.synchronized){
            this.setState( { orientation: {
                hlookat: res.hlookat,
                vlookat: res.vlookat,
                fov: res.fov
            }})
          }
        });
    }
    
    componentWillUnmount(){
        this.subscription.unsubscribe();
    }

    render(){
        return <RenderTour 
                    position={this.props.id} 
                    name={this.props.name} 
                    key={this.props.key}
                    orientation={this.state.orientation}
                    style={{width: "50px"}}
                />
    }

}

export default KrpanoTour